import { NotificationSubscription } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';
import { runInAction } from 'mobx';

declare const abp: any;

/**
 * Subscribes to InventoryStockChanged SignalR pushes and updates any currently
 * displayed stock: inventory list rows + dispatched service parts (selected and
 * additional) + the current-order's nested extras.
 */
export const useInventoryStockNotifications = () => {
  const { inventoryStore, serviceStore, orderStore } = useStore();

  useEffect(() => {
    const handler = (userNotification: any) => {
      const name = userNotification?.notification?.notificationName;
      if (name !== NotificationSubscription.InventoryStockChanged) return;

      const data = userNotification?.notification?.data?.properties;
      const inventoryId: string | undefined = data?.inventoryId;
      const quantity: number | undefined =
        typeof data?.quantity === 'number' ? data.quantity : Number(data?.quantity);
      if (!inventoryId || !Number.isFinite(quantity)) return;

      runInAction(() => {
        // Inventory table row
        const row = inventoryStore.inventories.get(inventoryId);
        if (row) row.quantity = quantity!;

        // Dispatched service parts (both selected + additional)
        const updateMap = (map: Map<number, any[]>) => {
          map.forEach((parts) => {
            parts.forEach((part) => {
              if (part.inventoryId === inventoryId) part.availableStock = quantity;
            });
          });
        };
        updateMap(serviceStore.selectedServiceParts);
        updateMap(serviceStore.additionalServiceParts);

        // Nested extras on the currently-loaded order
        orderStore.order?.serviceOrders?.forEach((so: any) => {
          so.extras?.forEach((extra: any) => {
            if (extra.inventoryId === inventoryId) extra.availableStock = quantity;
          });
        });
      });
    };

    abp.event.on('abp.notifications.received', handler);
    return () => abp.event.off('abp.notifications.received', handler);
  }, [inventoryStore, serviceStore, orderStore]);
};
